import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { PhoneNumberFormWithGdpr } from '~/@mid_ui/phone-number-form/PhoneNumberFormWithGdpr'
import { Button } from '~/shadcn/ui/button/button'
import { Field } from '~/shadcn/ui/field'
import { Spinner } from '~/shadcn/ui/spinner'
import { IsCompanySetter } from '../is-company-setter/IsCompanySetter'
import { PhoneNumberForm } from '~/@mid_ui/phone-number-form/PhoneNumberForm'

type Props = {
  showGdprCheckboxes: boolean
  handleSubmitForm: (props: {
    number: string
    gdpr?: boolean
    marketing?: boolean
  }) => void
  isPending: boolean
  error?: string
}

function PhoneVerificationForm({
  showGdprCheckboxes,
  handleSubmitForm,
  isPending,
  error,
}: Props) {
  return (
    <>
      {showGdprCheckboxes ? (
        <PhoneNumberFormWithGdpr
          handleSubmitForm={handleSubmitForm}
          isRequesting={isPending}
          error={error}
          SubmitButton={
            <div className="flex flex-col-reverse justify-start lg:flex-row mt-8 gap-4 w-full">
              <Button
                variant="accent"
                type="submit"
                size="2xl"
                className="gap-2">
                Registrácia{' '}
                {isPending ? (
                  <Spinner className="size-6" />
                ) : (
                  <ArrowForwardIcon className="w-10 h-10" />
                )}
              </Button>
            </div>
          }>
          <Field className="mt-6">
            <IsCompanySetter />
          </Field>
        </PhoneNumberFormWithGdpr>
      ) : (
        <PhoneNumberForm
          handleSubmitForm={handleSubmitForm}
          isRequesting={isPending}
          error={error}
          SubmitButton={
            <div className="flex flex-col-reverse justify-start lg:flex-row mt-8 gap-4 w-full">
              <Button
                variant="accent"
                type="submit"
                size="2xl"
                className="gap-2">
                Registrácia{' '}
                {isPending ? (
                  <Spinner className="size-6" />
                ) : (
                  <ArrowForwardIcon className="w-10 h-10" />
                )}
              </Button>
            </div>
          }>
          <Field className="mt-6">
            <IsCompanySetter />
          </Field>
        </PhoneNumberForm>
      )}
    </>
  )
}

export { PhoneVerificationForm }
